import React from 'react';
import Input from './Input';

interface PasswordRequirements {
  minLength: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

interface PasswordInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  // eslint-disable-next-line react/require-default-props
  label?: string;
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  touched?: boolean;
  // eslint-disable-next-line react/require-default-props
  showRequirements?: boolean;
  // eslint-disable-next-line react/require-default-props
  passwordRequirements?: PasswordRequirements;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  error,
  touched,
  showRequirements = false,
  passwordRequirements,
  ...props
}) => {
  return (
    <div>
      <Input
        type="password"
        label={label}
        error={error}
        touched={touched}
        {...props}
      />
      {showRequirements && passwordRequirements && (
        <div className="mt-2 space-y-1">
          <p className="text-xs font-medium text-gray-700 mb-2">
            Password must contain:
          </p>
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-xs">
              <span
                className={`${
                  passwordRequirements.minLength
                    ? 'text-green-600'
                    : 'text-gray-400'
                }`}
              >
                {passwordRequirements.minLength ? '✓' : '○'}
              </span>
              <span
                className={
                  passwordRequirements.minLength
                    ? 'text-gray-700'
                    : 'text-gray-500'
                }
              >
                At least 8 characters
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs">
              <span
                className={`${
                  passwordRequirements.hasUpperCase
                    ? 'text-green-600'
                    : 'text-gray-400'
                }`}
              >
                {passwordRequirements.hasUpperCase ? '✓' : '○'}
              </span>
              <span
                className={
                  passwordRequirements.hasUpperCase
                    ? 'text-gray-700'
                    : 'text-gray-500'
                }
              >
                One uppercase letter
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs">
              <span
                className={`${
                  passwordRequirements.hasLowerCase
                    ? 'text-green-600'
                    : 'text-gray-400'
                }`}
              >
                {passwordRequirements.hasLowerCase ? '✓' : '○'}
              </span>
              <span
                className={
                  passwordRequirements.hasLowerCase
                    ? 'text-gray-700'
                    : 'text-gray-500'
                }
              >
                One lowercase letter
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs">
              <span
                className={`${
                  passwordRequirements.hasNumber
                    ? 'text-green-600'
                    : 'text-gray-400'
                }`}
              >
                {passwordRequirements.hasNumber ? '✓' : '○'}
              </span>
              <span
                className={
                  passwordRequirements.hasNumber
                    ? 'text-gray-700'
                    : 'text-gray-500'
                }
              >
                One number
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs">
              <span
                className={`${
                  passwordRequirements.hasSpecialChar
                    ? 'text-green-600'
                    : 'text-gray-400'
                }`}
              >
                {passwordRequirements.hasSpecialChar ? '✓' : '○'}
              </span>
              <span
                className={
                  passwordRequirements.hasSpecialChar
                    ? 'text-gray-700'
                    : 'text-gray-500'
                }
              >
                One special character (!@#$%^&*)
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
